import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedPoliceReportUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDiffList,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface PoliceReportUpdatedEventProps {
  event: DiscriminatedPoliceReportUpdatedEvent;
}

export const PoliceReportUpdatedEvent: React.FC<
  PoliceReportUpdatedEventProps
> = ({ event }) => {
  const { police_report, diff } = event.payload;
  const user = getUserFromEvent(event);

  const departmentName = police_report?.police_department?.name;
  const reportIdentifier = police_report?.report_identifier;

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-amber-100">
          <PencilIcon className="h-4 w-4 text-amber-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {(departmentName || reportIdentifier) && (
        <ActivityTitle>{departmentName || reportIdentifier}</ActivityTitle>
      )}
      {diff && <ActivityDiffList diff={diff} defaultExpanded={false} />}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Police Report Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
